import React, { useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import ProfileModal from './ProfileModal';
import './Header.css';

const ALL_NAV_LINKS = [
  { path: '/products', label: '📦 產品管理', roles: ['manager', 'purchasing', 'sales'] },
  { path: '/catalog', label: '📑 型錄管理', roles: ['manager', 'purchasing', 'sales'] },
  { path: '/customers', label: '👥 客戶管理', roles: ['manager', 'sales'] },
  { path: '/quotes', label: '📋 報價單', roles: ['manager', 'sales'] },
  { path: '/accounts', label: '⚙️ 帳號管理', roles: ['manager'] },
];

const Header = ({ title, user, onLogout, actions, onUserUpdate }) => {
  const [showProfile, setShowProfile] = useState(false);

  const getRoleBadge = (role) => {
    const badges = {
      manager: { text: '主管', icon: '👔', class: 'manager' },
      purchasing: { text: '採購', icon: '📦', class: 'purchaser' },
      sales: { text: '業務', icon: '💼', class: 'sales' }
    };
    return badges[role] || badges.sales;
  };

  const badge = getRoleBadge(user?.role);

  const navLinks = useMemo(() => {
    const role = user?.role;
    if (!role) return [];
    return ALL_NAV_LINKS.filter(link => link.roles.includes(role));
  }, [user?.role]);

  return (
    <header className="page-header">
      <div className="header-content">
        <div className="logo">
          <h1>{title}</h1>
        </div>
        <nav className="header-nav">
          {navLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              end
              className={({ isActive }) => `header-nav-btn${isActive ? ' active' : ''}`}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
        <div className="header-actions">
          {actions}
          <div className="current-user">
            <div className="current-user-avatar">{user?.name?.[0] || 'U'}</div>
            <span>{user?.name}</span>
            <span className={`role-badge role-badge-${badge.class}`}>
              {badge.text}
            </span>
          </div>
          <button className="btn btn-outline btn-sm" onClick={() => setShowProfile(true)}>
            個人設定
          </button>
          <button className="btn btn-outline btn-sm" onClick={onLogout}>
            登出
          </button>
        </div>
      </div>

      <ProfileModal
        show={showProfile}
        onClose={() => setShowProfile(false)}
        user={user}
        onUserUpdate={onUserUpdate}
      />
    </header>
  );
};

export default Header;
